import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader from '@contexts/sportsHeader'
import { SportsHeaderContextType } from '@contexts/sportsHeader'
import { ViewportTypeValues } from '@contexts/viewport'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledHalvesHeaderProps = Pick<
  SportsHeaderContextType,
  'teaserFlex' | 'teaserType' | 'isInMegaModule'
>

const { SportsHeaderContext } = contextSportsHeader

const StyledHalvesHeader = styled.div<StyledHalvesHeaderProps>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  ${({ teaserFlex, teaserType, isInMegaModule }) => {
    let headerHeightDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    let headerHeightTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })

    let headerHeightMobile

    if (
      teaserType === 'listitem' ||
      (teaserType === 'standard' && isInMegaModule)
    ) {
      headerHeightDesktop = '38px'
      headerHeightTablet = '38px'
    } else {
      if (desktopTeaserFlex === '6') {
        headerHeightDesktop = `${0.05952 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '4') {
        headerHeightDesktop = `${0.09036 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '3') {
        headerHeightDesktop = `${0.10569 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '2') {
        headerHeightDesktop = `${0.125 * teaserWidthDesktop}px`
      }

      if (tabletTeaserFlex === '6') {
        headerHeightTablet = `${0.09036 * teaserWidthTablet}px`
      } else if (tabletTeaserFlex === '3') {
        headerHeightTablet = `${0.10569 * teaserWidthTablet}px`
      }
    }

    if (['standard', 'listitem'].includes(teaserType)) {
      headerHeightMobile = '38px'
    } else {
      headerHeightMobile = '12vw'
    }

    return css`
      ${desktopCSS(css`
        height: ${headerHeightDesktop};
      `)}

      ${tabletCSS(css`
        height: ${headerHeightTablet};
      `)}
      
      ${mobileCSS(css`
        height: ${headerHeightMobile};
      `)}
    `
  }}
`

const HalvesHeader: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { teaserFlex, teaserType, isInMegaModule } =
    useContext(SportsHeaderContext)
  return (
    <StyledHalvesHeader
      teaserFlex={teaserFlex}
      teaserType={teaserType}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledHalvesHeader>
  )
}

export default HalvesHeader
